import { PaypalPaymentModal } from "./PaypalPayment.model";
import { BuyIpsProductReturn } from "./BuyIpsProductReturn.model";

export class FinalProductPaymentModal{
    constructor(
        private HaLicense:PaypalPaymentModal,
        private BoughtProductsList:BuyIpsProductReturn,
        private invoiceHtmlContent:string,
        private isReoccured:boolean,
        private TransactionId:string


    ){

    }
}